import { getNextRoute } from '@dvp/helpers/Route'

import basketStore from '@shared/store/basket'
import productStructureStore from '@shared/store/productStructure'
import useBasket from '@shared/hooks/useBasket'
import useIncentive from '@shared/hooks/useIncentive'
import usePerson from '@shared/hooks/usePerson'
import usePersonDetails from '@shared/hooks/usePersonDetails'
import useStatus from '@shared/hooks/useStatus'


import { CATEGORY_TYPE, ROUTE_INDEX, ROUTE_NAME } from '@shared/config/constants'

function beforeEnter(to, _from, next) {
  const { isStaticBasket } = useBasket()
  const { isPersonalDataValid } = useStatus()
  const { filterPersonsToValidate } = usePerson()

  if (basketStore.basket.persons.length === 0) {
    next({
      name: ROUTE_NAME.PERSONS,
      params: {
        lang: to.params.lang,
      },
    })
  } else {
    productStructureStore.ready().then(() => {
      if (!isPersonalDataValid(filterPersonsToValidate(basketStore.basket)) || isStaticBasket.value) {
        next({
          name: getNextRoute(basketStore.basket),
          params: {
            lang: to.params.lang,
          },
        })
      } else if (!to.params.personId) {
        next({
          name: ROUTE_NAME.OFFERS,
          params: {
            lang: to.params.lang,
            personId: filterPersonsToValidate(basketStore.basket)[0].personId,
            categoryId: 'KVG',
          },
        })
      } else if (!to.params.categoryId) {
        next({
          name: ROUTE_NAME.PRODUCT_CATEGORY,
          params: {
            lang: to.params.lang,
            personId: to.params.personId,
            categoryId: CATEGORY_TYPE.KVG,
          },
        })
      } else {
        next()
      }
    })
  }
}

export default [
  {
    beforeEnter,
    name: ROUTE_NAME.OFFERS_ALT,
    path: 'products/',
    children: [
      {
        component: () => import('@dvp/screens/Products/ScreenProduct'),
        meta: {
          index: ROUTE_INDEX.OFFERS,
        },
        name: ROUTE_NAME.OFFERS,
        path: ':personId',
        props: true,
        children: [
          {
            component: () => import('@dvp/screens/Products/ScreenGroups'),
            meta: {
              index: ROUTE_INDEX.OFFERS,
            },
            name: 'groups-collective',
            path: ':categoryId(SCPC_ADDITIONAL)',
            props: route => ({
              categoryId: route.params.categoryId,
              groupId: route.params.groupId || '',
              personId: route.params.personId,
              hasFilter: true,
              isGrouped: true,
            }),
          },
          {
            component: () => import('@dvp/screens/Products/ScreenGroups'),
            meta: {
              index: ROUTE_INDEX.OFFERS,
            },
            name: ROUTE_NAME.PRODUCT_CATEGORY,
            path: ':categoryId',
            props: route => ({
              categoryId: route.params.categoryId,
              groupId: route.params.groupId || '',
              personId: route.params.personId,
              hasFilter: route.params.categoryId === CATEGORY_TYPE.KVG,
              isGrouped: route.params.categoryId !== CATEGORY_TYPE.KVG,
            }),
          },
        ],
      },
    ],
  },
  {
    beforeEnter: (to, _from, next) => {
      const { incentives } = useIncentive()
      const selectedQuiz = incentives.value.find(i => i.id === to.params?.incentiveId)

      if (!selectedQuiz) {
        next({ name: getNextRoute(basketStore.basket) })
      } else {
        next()
        // @note: why beforeEnter again? loooooop
        //beforeEnter(to, from, next)
      }
    },
    component: () => import('@dvp/screens/Products/ScreenIncentive'),
    meta: {
      index: ROUTE_INDEX.OFFERS_INCENTIVE,
    },
    name: ROUTE_NAME.OFFERS_INCENTIVE,
    path: 'products-incentive/:incentiveId/:personId',
    props: true,
  },
  {
    beforeEnter: (to, _from) => {
      if (basketStore.basket.persons.length === 0) {
        return {
          name: ROUTE_NAME.PERSONS,
          params: {
            lang: to.params.lang,
          },
        }
      } else if (!to.params.personId) {
        const { getPersonsByMutability } = usePersonDetails()
        const personsList = getPersonsByMutability()

        return {
          ...to,
          params: {
            ...to.params,
            personId: personsList.mutable[0].personId
          }
        }
      } else {
        return
      }
    },
    component: () => import('@dvp/screens/Products/OfferVariants'),
    meta: {
      index: ROUTE_INDEX.OFFER_VARIANTS,
      navigation: false,
    },
    name: ROUTE_NAME.OFFER_VARIANTS,
    path: 'offer-variants/:personId?',
    props: true,
  },
]
